
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import "../../assets/css/Loader.css";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Select from "react-select";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { format } from "date-fns";
import ActionsDropdown from "../ActionsDropdown";
import { useNavigate } from "react-router-dom";
const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(odd) {
    background-color: #f2f2f2; /* Light gray for even rows */
  }

  tr:nth-child(even) {
    background-color: #ffffff; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;


function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Completed() {
  const [responseData, setResponseData] = useState([]);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);

  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});

  useEffect(() => {
    fetchData();
    gettoken();
    getprevillages();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl + "/student_completed", {
        params: { data: localStorage.getItem("branch_id") }
      });
      console.log("Response from server:", response.data);


      if (response && response.status === 200) {
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }



      const filteredData = response.data.filter(
        (item) => item.completed === "Completed" && item.callbackdate !== null
      );

      setResponseData(response.data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };


  const fetchDataed = async () => {
    try {
      const branchName = localStorage.getItem("branch_name");
      if (branchName === 'Branches') {
        setLoading(true);
        const response = await axios.get(apiUrl + "/student_completed", {
          params: { data: localStorage.getItem("branch_id") }
        });
        console.log("Response from server:", response.data);

        if (response && response.status === 200) {
          setTimeout(() => {
            setLoading(false);
          }, 300);
        }
        const filteredData = response.data.filter(
          (item) => item.completed === "Completed" && item.callbackdate !== null
        );

        setResponseData(response.data.reverse());
      } else {
        const username = localStorage.getItem("username");
        const internal_emp = localStorage.getItem("internal_emp");

        setLoading(true);
        const response = await axios.get(apiUrl + "/student_completed", {
          // params: { data: localStorage.getItem("branch_id") }
        });
        console.log("Response from server:", response.data);

        if (response && response.status === 200) {
          setTimeout(() => {
            setLoading(false);
          }, 300);
        }

        const filteredStaffData = response.data.filter(
          (item) => item.staff_data[0]?.empid === username || item.staff_data[0]?.empid === internal_emp
        );


        setResponseData(filteredStaffData);
      }
    } catch (error) {

    }
  }




  //   const fetchData = async () => {
  //     try {
  //         const response = await axios.get(apiUrl + "/student_completed");
  //         console.log("Response from server:", response.data);

  //         // Filter the data for items that are "Completed" and have a non-null callbackdate
  //         const filteredData = response.data.filter(
  //             (item) => item.completed === "Completed" && item.callbackdate !== null
  //         );

  //         // Reverse the filtered data without mutating the original array
  //         setResponseData(filteredData.reverse());
  //     } catch (error) {
  //         console.error("Error fetching data:", error.message);
  //     }
  // };

  const gettoken = async () => {
    const token = localStorage.getItem("token");
    // console.log("the toekn in the localStorage is : ",token);
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      // setResponseData(response.data);

      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);
      console.log("the role_id is : ", role_id);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      // getpages();

      if (id) {
        // try {
        //   const response = await axios.get(apiUrl + `/role_2/${id}`);

        //   console.log("the reponse list in brach is : ", response.data.modules);

        //   const modules = response.data.modules;

        //   const filtered_access = modules.filter(
        //     (item) => item.name == "Branch"
        //   );

        //   console.log("the modules is : ", filtered_access[0].actions);

        //   setprevillages(filtered_access[0].actions);

        //   console.log("the assigned previllages is : ", previllages.add);
        // } catch (error) {
        //   console.error("Error fetching data:", error.message);
        // }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find((item) => item.name == "Completed")

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions)
  }






  const [updateData, setUpdateData] = useState({
    student_name: "",
    total_fees: "",
    paid: "",
    balance: "",
    status: "",
    completed: "",
    completed_date: "",
    roll_no: "",
    photo_upload: "",
    id_proof: "",
    image: null,
    imagePreview: null, // To store the preview URL
  });

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Search
  const filtered = currentItems.filter((item) =>
    // Object.values(item.leads_id[0]).some(
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const [updateid, setUpdateId] = useState([]);


  // useEffect(() => {
  //   updateid.data.
  // }, []);

  const handleUpdate = async (_id, data) => {
    // console.log("IOFJDSJGDF",data)
    if (previllages.edit || previllages.all) {
      setUpdateShowModal(true);
      const responseid = await axios.get(`${apiUrl}/student/${_id}`);
      console.log(responseid.data[0], "responseid---", _id);
      const data = responseid.data[0];
      setUpdateId({
        _id: _id,
        student_name: data.student_name_lead,
        roll_no: data.roll_no,
        fees: data.fees,
        course_status: data.course_status,
        certificate_status: data.certificate_status,
        completion_date: data.completion_date,
        image: data.image || null,
        imagePreview: data.imagePreview || null // To store the preview URL


      });
    } else {
      toast.error("You don't have the permission to update");
    }
  };



  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Generate a preview URL
      const previewUrl = URL.createObjectURL(file);

      // Use a functional update to ensure you're working with the most recent state
      setUpdateId((prevUpdateId) => ({
        ...prevUpdateId,
        image: file, // Update the image property with the new file
        imagePreview: previewUrl, // Set the preview URL for the image
      }));
    }
  };



  const handleupdatesubmit = async (e, id) => {
    e.preventDefault(); // This prevents the default form submission behavior

    try {
      setLoading(true);
      const formDataupdate = {
        course_status: updateid.course_status,
        certificate_status: updateid.certificate_status,
        completion_date: updateid.completion_date,
        image: updateid.image,
        imagePreview: updateid.imagePreview
      };
      console.log("the update submit data", formDataupdate);

      const response = await axios.put(
        apiUrl + `/student/${String(id)}`,
        formDataupdate,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("response for update", response);
      setUpdateShowModal(false);
      toast.success("update successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };
  //delete

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const handleOpenModal = async (_id, student_name_lead) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the studentname", student_name_lead);
      setdeleteid(_id);
      setdeletename(student_name_lead);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission to delete");
    }
  };

  const handleDelete = async (_id) => {
    try {
      setLoading(true);
      const response = await axios.delete(apiUrl + `/student/${getdeleteid}`);
      console.log("delete data ", response);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const totalPages = Math.ceil(responseData.length / itemsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === totalPages ? prevPage : prevPage + 1
    );
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
  };
  // the pagination  end ---------------------------------------------------------------------




  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };


  // =================================================================
  const navigate = useNavigate();

  const updateinfo = (id) => {
    navigate(`/StudentInfo/${id}`);
  };

  const [rolename, setrolename] = useState([]);
  useEffect(() => {

    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const [loading, setLoading] = useState(false);


  const data = useMemo(() => {
    return responseData.map((item, index) => ({
      _id: item._id,
      admission_date: item.admission_date,
      duraction: item.duraction,
      batch_timings: item.batch_timings,
      father_name: item.father_name,
      qualification: item.qualification,
      discount: item.discount,
      fees: item.fees,
      student_type: item.student_type,
      payment_type: item.payment_type,
      roll_no: item.roll_no,
      photo_upload: item.photo_upload,
      id_proof: item.id_proof,
      leads_id: item.leads_id,
      course_id: item.course_id,
      date_of_birth: item.date_of_birth,
      trainer: item.trainer,
      register_no: item.register_no,
      placement: item.placement,
      duraction_time: item.duraction_time,
      branch_lead: item.branch_lead,
      student_name_lead: item.student_name_lead,
      mobile_no_lead: item.mobile_no_lead,
      email_lead: item.email_lead,
      Prefered_course_lead: item.Prefered_course_lead,
      purpose_enquiry_lead: item.purpose_enquiry_lead,
      Enquiry_date_lead: item.Enquiry_date_lead,
      Source_type_lead: item.Source_type_lead,
      contact_type_lead: item.contact_type_lead,
      assign_staff_lead: item.assign_staff_lead,
      referal_candidate_name_lead: item.referal_candidate_name_lead,
      referal_candidate_lead: item.referal_candidate_lead,
      followups_time_lead: item.followups_time_lead,
      followups_date_lead: item.followups_date_lead,
      status_time_lead: item.status_time_lead,
      followups_status_lead: item.followups_status_lead,
      followups_notes_lead: item.followups_notes_lead,
      interest_lead: item.interest_lead,
      course_status: item.course_status,
      certificate_status: item.certificate_status,

      branch_details: item.branch_details.map(branch => ({
        _id: branch._id,
        branch_id: branch.branch_id,
        branch_name: branch.branch_name,
        status: branch.status,
        address: branch.address,
        email_id: branch.email_id,
        phone_no: branch.phone_no,
      })),
      serialNo: index + 1, // Correct serial number assignment
    }));
  }, [responseData]);



  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: "S.No",
        accessor: "serialNo",
        disableFilters: true, // Disable filters for S.No
      },
      {
        Header: "Student",
        accessor: "student_name_lead",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => value || "No Student Name", // Fallback for missing student names
      },
      {
        Header: "Course",
        accessor: "Prefered_course_lead",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => value || "No Course", // Fallback for missing course names
      },
      {
        Header: "Mobile No",
        accessor: "mobile_no_lead",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => value || "No Mobile", // Fallback for missing mobile numbers
      },
      {
        Header: "Course Status",
        accessor: "course_status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          const getStatusStyle = (status) => {
            switch (status) {
              case "Completed":
                return {
                  backgroundColor: "green",
                  color: "white",
                  padding: "2px 8px",
                  borderRadius: "5px",
                };
              case "Inprogress":
                return {
                  backgroundColor: "orange",
                  color: "white",
                  padding: "2px 8px",
                  borderRadius: "5px",
                };
              case "Pending":
                return {
                  backgroundColor: "red",
                  color: "white",
                  padding: "2px 8px",
                  borderRadius: "5px",
                };
              default:
                return {
                  backgroundColor: "grey",
                  color: "white",
                  padding: "2px 8px",
                  borderRadius: "5px",
                };
            }
          };

          return (
            <span
              style={{
                display: "inline-block",
                width: "120px",
                height: "20px",
                lineHeight: "15px",
                textAlign: "center",
                ...getStatusStyle(value),
              }}
            >
              {value || "No Status"}
            </span>
          );
        },
      },
      {
        Header: "Course Certificate",
        accessor: (row) => row.certificate_status || "Inprogress", // Fallback to "Inprogress" if certificate_status is falsy
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
    ];

    // Conditionally add the "Branch" column based on rolename
    // if (rolename === "Branches") {
    //   baseColumns.push({
    //     Header: "Branch",
    //     accessor: (row) => row.branch_details[0]?.branch_name || "N/A", // Default "N/A" if branch name is missing
    //     Filter: DefaultColumnFilter,
    //     filter: "multiSelectFilter",
    //   });
    // }

    return baseColumns;
  }, [rolename]); // Depend on rolename to re-evaluate when it changes


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );



  return (
    <>

      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}



      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-11">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Completed</b>
              </Link>
              {/* <Link to="" className="text-danger dashBoard_text">
                            <b>Profile</b>
                        </Link> */}
            </div>
          </div>
        </div>



        {/* ------------ search and per page ----------------------------*/}

        {/* --------------------------------end------------------------------------------- */}

        {/* Table */}

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div className="d-flex">
                <h5>Completed Student</h5>
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

              {/* </div>

            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) => {
                        setLoading(true);
                        setTimeout(() => {
                          handleUpdate(id, row);
                          setLoading(false);
                        }, 500);
                      }}
                      onDelete={(id, row) => {
                        handleOpenModal(id, row.student_name_lead);
                      }}
                      onInfo={(id, row) => {
                        setLoading(true);
                        setTimeout(() => {
                          updateinfo(row._id);
                          setLoading(false);
                        }, 500);
                      }}
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>




        {/* _------------------------------pagination button -------------------------------- */}
        <div className="mt-3 pb-5">






          <Modal
            show={isUpdateshowModal}
            onHide={() => setUpdateShowModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title id="modeti"> Update Studying Completed</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="floating-label">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    disabled
                    placeholder=""
                    value={updateid.student_name}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        student_name: e.target.value,
                      })
                    }
                    required
                  />
                  <label className={updateData.student_name ? "filled" : ""}>
                    Student name
                  </label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    disabled
                    placeholder=""
                    value={updateid.roll_no}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, roll_no: e.target.value })
                    }
                    required
                  />
                  <label className={updateData.roll_no ? "filled" : ""}>
                    Roll No
                  </label>
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    disabled
                    placeholder=""
                    value={updateid.fees}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, paid: e.target.value })
                    }
                    required
                  />
                  <label className={updateData.paid ? "filled" : ""}>Fees</label>
                </div>

                <div className="floating-label">
                  <select
                    className="form-control"
                    value={updateid.course_status || ""}
                    onChange={(e) =>
                      setUpdateId({ ...updateid, course_status: e.target.value })
                    }
                    required
                  >
                    <option value="">Select status</option>
                    <option value="Completed">Completed</option>
                    <option value="Studying">Studying</option>
                    <option value="Discontinue">Discontinue</option>
                  </select>

                  <label className={updateid.course_status ? "filled" : ""}>
                    Selected Status
                  </label>
                </div>

                <div className="floating-label">
                  {/* Certificate Status Dropdown */}
                  <select
                    className="form-control"
                    value={updateid.certificate_status || ""}
                    onChange={(e) =>
                      setUpdateId({
                        ...updateid,
                        certificate_status: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="">Certificate Status</option>
                    <option value="Inprogress">Inprogress</option>
                    <option value="Pending">Pending</option>
                    <option value="Delivered">Delivered</option>
                  </select>

                  <label className={updateid.certificate_status ? "filled" : ""}>
                    Certificate Status
                  </label>
                </div>

                {/* Conditionally Rendered Date Input */}
                {updateid.certificate_status === "Completed" && (
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      value={updateid.completion_date || ""}
                      onChange={(e) =>
                        setUpdateId({
                          ...updateid,
                          completion_date: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateid.completion_date ? "filled" : ""}>
                      Completion Date
                    </label>
                  </div>
                )}



                {/* adding completion_date conditionally for Completed status */}
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="file"
                    onChange={handleFileChange}
                  />
                  <label className={updateid.image ? "filled" : ""}>
                    Certificate Upload
                  </label>
                </div>

                {updateid.imagePreview && (
                  <div className="image-preview">
                    <img
                      src={updateid.imagePreview}
                      alt="Certificate Preview"
                      style={{ width: '250px', height: 'auto', marginTop: '10px' }}
                    />
                  </div>
                )}


                {updateid.course_status === "Completed" && (
                  <div className="floating-label mt-3">
                    <input
                      className="form-control"
                      type="date"
                      value={updateid.completion_date || ""}
                      onChange={(e) =>
                        setUpdateId({
                          ...updateid,
                          completion_date: e.target.value,
                        })
                      }
                      required
                      style={{
                        backgroundColor: "#ffcccc",  // Light red background
                        borderColor: "#ff0000",       // Red border (optional)
                        colorScheme: "red"          // Red color scheme for calendar popup

                      }}
                    />
                    <label className={updateid.completion_date ? "filled" : ""}>
                      Completion Date
                    </label>
                  </div>
                )}

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="file"
                    // onChange={(e) => {
                    //   const file = e.target.files[0]; // Get the first file selected
                    //   if (file) {
                    //     // Use a functional update to ensure you're working with the most recent state
                    //     setUpdateId((prevUpdateId) => ({
                    //       ...prevUpdateId, // Spread the previous state
                    //       image: file // Update the image property with the new file
                    //     }));
                    //   }
                    // }}

                    onChange={handleFileChange}
                    required
                  />
                  <label className={updateid.image ? "filled" : ""}>
                    Image Upload
                  </label>
                </div>



                {updateid.imagePreview && (
                  <div className="image-preview">
                    <img
                      src={updateid.imagePreview}
                      alt="Preview"
                      style={{ width: '250px', height: 'auto', marginTop: '10px' }}
                    />
                  </div>
                )}




              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                className="cancelbut"
                variant="secondary"
                onClick={() => setUpdateShowModal(false)}
              >
                Cancel
              </Button>
              <Button
                className="submitbut"
                variant="primary"
                onClick={(e) => handleupdatesubmit(e, updateid._id)}
              >
                Update
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        {/* ----------------delete */}

        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1"> Student Name :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
        {/* ---------------------------------------end ---------------------------------- */}


        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {state.pageIndex + 1} of {pageCount}
              </span>
            </div>
            <div className="col-lg-5">
              <div className="mt-3 pb-5">
                <nav>
                  <ul className="pagination justify-content-center">
                    {createPagination()} {/* Pagination buttons */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Completed;
